import Linechart from 'src/components/charts/line-chart'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import {computed, watch} from 'vue'
import { NO_EARNING, NO_ORDER, FOUNDRY_SUPPORT_URL, EMPTY_REPORT_URL } from 'src/utils/constants/common'
import { isEmpty, isEqual } from 'lodash'
import DOMPurify from 'dompurify';
import { MdButton, MdIconReports } from '@antiqua-dls/vue-components'

// eslint-disable-next-line import/order
import { CJA_EVENTS, LINK_CATEGORIES, LINK_SECTION, LINK_NAMES, LINK_TYPES } from '../../../../../../modules/adobe-cja/constants'
import { adobeCjaEventEmitter } from '../../../../../../modules/adobe-cja/utils'

export default{
  components:{
    Linechart,
    MdButton,
    MdIconReports
  },
  setup(){
    const router = useRouter()
    const store = useStore()
    const earningGraphMetaData = computed(()=> store.getters['dashboard/getGraphMetaData'])
    const hasReportData = computed(() => !isEmpty(earningGraphMetaData.value?.total) || earningGraphMetaData.value?.total >0 )
    const reportLabel = computed(() => isEqual(earningGraphMetaData.value?.label, 'total_orders') ? 'orders' : 'earnings' )
    const isEarningReport = computed(()=> isEqual(store.getters['dashboard/getReportType'], 'earnings'))
    const sanitizeUrl = (url) => {
      return DOMPurify.sanitize(url)
    }
    const foundrySupportUrl = sanitizeUrl(FOUNDRY_SUPPORT_URL)
    const emptyReportUrl = sanitizeUrl(EMPTY_REPORT_URL)
    const lineChartData = computed(() => {
      if (isEarningReport.value) {
        return store.getters['dashboard/getEarningGraphData']
      } else {
        return store.getters['dashboard/getOrderGraphData']
      }
    })

    const gotoReport = ()=>{
      adobeCjaEventEmitter({
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: LINK_CATEGORIES.VIEW_REPORT,
          linkSection: LINK_SECTION.DASHBOARD,
          linkName: LINK_NAMES.VIEW_REPORT,
          linkType: LINK_TYPES.BUTTON
        }
      })
      router.push({ name: 'earnings_report_dashboard' })
      store.commit('dashboard/setViewedFromReportBtn', true)
    }
    //WatchEffect is not working as expected
    watch(() => isEarningReport.value, () => {
      if(isEarningReport.value){
        store.dispatch('dashboard/modifiedEarningGraphData')
      }else{
        store.dispatch('dashboard/modifiedOrderGraphData')
      }
    }, { immediate: true })

    return {
      earningGraphMetaData,
      hasReportData,
      reportLabel,
      isEarningReport,
      gotoReport,
      NO_EARNING,
      NO_ORDER,
      FOUNDRY_SUPPORT_URL,
      lineChartData,
      EMPTY_REPORT_URL,
      emptyReportUrl,
      foundrySupportUrl
    }
  }
}
